export const TOOLTIP_INFO = 'TOOLTIP_INFO';
export const TOOLTIP_WARNING = 'TOOLTIP_WARNING';
export const TOOLTIP_ERROR = 'TOOLTIP_ERROR';

export const TOOLTIP_ICON_LOCK = 'fa-lock';
export const TOOLTIP_ICON_INFO = 'fa-info-circle';

export const COLOR_RED = 'red';
export const COLOR_BLUE = 'blue';
export const COLOR_YELLOW = 'yellow';
export const COLOR_GREEN = 'green';
export const COLOR_PURPLE = 'purple';
export const COLOR_PINK = 'pink';
export const COLOR_ORANGE = 'orange';
export const COLOR_TURQUOISE = 'turquoise';
export const COLOR_PINK_LIGHT = 'pink-light';
export const COLOR_GREEN_LIGHT = 'green-light';
export const COLOR_TURQUOISE_DARK = 'turquoise-dark';
export const COLOR_BLUE_DARK = 'dark-blue';
export const COLOR_WHITE = 'white';
export const COLOR_BLACK = 'black';
export const COLOR_GRAY_LIGHT = 'gray-light';

export const FONT_ICON_EXCLAMATION = 'fa-exclamation';

export const ICON_ORGANISATIE = 'ICON_ORGANISATIE';
export const ICON_IDENTIFICATIE = 'ICON_IDENTIFICATIE';
export const ICON_ADRES = 'ICON_ADRES';
export const ICON_SPORTINFRASTRUCTUUR = 'ICON_SPORTINFRASTRUCTUUR';
export const ICON_SPORTTAKKEN = 'ICON_SPORTTAKKEN';
export const ICON_DOELGROEP = 'ICON_DOELGROEP';
export const ICON_SOCIALEMEDIA = 'ICON_SOCIALEMEDIA';
export const ICON_LINKS = 'ICON_LINKS';
export const ICON_EXTRACOMMENTAAR = 'ICON_EXTRACOMMENTAAR';

export const DEFAULT_MIME_TYPES = ''.concat(
    'application/pdf,',
    'application/vnd.ms-excel,',
    'application/msexcel,',
    'application/x-excel,',
    'application/x-msexcel,',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,',
    'application/msword,',
    'application/vnd.ms-word,',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document,',
    'application/mspowerpoint,',
    'application/vnd.ms-powerpoint,',
    'application/x-mspowerpoint,',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation,',
    'image/jpeg,',
    'image/gif,',
    'image/png,',
    'image/tiff,'
);

export const FileComponentNames = {
    DEMO: "filesComponent"
};

export const ValidationMessageTypes = {
    ERROR: "error",
    WARNING: "warning"
};

export const DEFAULT_FILE_EXTENSIONS = 'pdf, xls, xlsx, doc, docx, ppt, pptx, jpeg, jpg, gif, png, tiff';